export default __webpack_public_path__ + "static/media/CALPCC-Logo-1.76a2f936.png";